import { ToastContainer } from "react-toastify";
import styled from "styled-components";
import { Colors } from "../../ColorConstants";
import "react-toastify/dist/ReactToastify.css";
const Toast = () => {
  return <StyledContainer/>;
};

const StyledContainer = styled(ToastContainer)`
  .Toastify__toast {
    font-familyt:"Poppins";
    color:white;
    background-color:${Colors.blackOpacity};
  }
`;
export default Toast;
